import { useContext, useRef, useEffect } from 'react';
import { MyContext } from '../../Context/MyProvider';
import { showToast } from '../../showTost';
import VegIcon from "../../Icon/veg.svg";
import NonVegIcon from "../../Icon/nonveg.svg";

const AddonItemData = ({ data, index, currency, addondata, setSelectAddonItem, selectaddonitem, hasSubAddon, setSubAddonData, Required, setItemState, itemstate, isedit, ischnage, copyitemstate }) => {

    const { customisableitem, setCustomisableItem, isVegtype } = useContext(MyContext);
    const isadded = hasSubAddon ? Boolean(selectaddonitem.find(item => item.id === data.id)) : itemstate.some(List => List.data.some(item => item.id === data.id));
    const hasInitialized = useRef(false);

    useEffect(() => {
        if (isedit === 0) {
            if (!hasInitialized.current && hasSubAddon && !ischnage && index === 0 && addondata.addon_is_radio === "1") {
                handleFilterData(data);
                hasInitialized.current = true;
            }
        } else {
            if (!hasInitialized.current && hasSubAddon && !ischnage && addondata.addon_is_radio === "1") {
                const FindData = selectaddonitem.find(item => data.id === item.id);
                if (FindData) {
                    handleFilterData(FindData);
                }
            }
        }
    }, []);

    const handleSelectItem = (data) => {
        const FilterData = customisableitem.addondata.map((item) => {
            if (item.id === addondata.id) {
                if (item.addon_is_radio === "1") {
                    if (!item.additem) {
                        if (hasSubAddon) {
                            setSelectAddonItem(prev => [...prev, data]);
                        } else {
                            handleItemAdd(data);
                        }
                        return { ...item, additem: "1" };
                    } else {
                        if (!isadded) {
                            if (hasSubAddon) {

                                const updatedItems = selectaddonitem.filter(addonItem => {
                                    return !item.addon_item_data.some(list => list.id === addonItem.id);
                                });

                                setSelectAddonItem([...updatedItems, data]);
                            }

                            handleItemRemove(1, item);
                            handleFilterData(data);
                        }
                    }
                } else {
                    if (String(item.additem) !== Required) {

                        const isAdded = itemstate.some(item => item.data.some(dataitem => dataitem.title === data.title));

                        if (isAdded) {
                            if (hasSubAddon) {
                                const updateaddonitem = selectaddonitem.filter(item => item.id !== data.id);
                                setSelectAddonItem(updateaddonitem);
                            }
                            handleItemRemove(2, item);
                        } else {
                            if (hasSubAddon) {
                                setSelectAddonItem(prev => [...prev, data]);
                            }
                            handleItemAdd(data);
                            const Count = item.additem ? Number(item.additem) + 1 : 1;
                            return { ...item, additem: String(Count) };
                        }
                    } else {

                        if (isadded) {
                            const updateaddonitem = selectaddonitem.filter(item => item.id !== data.id);
                            setSelectAddonItem(updateaddonitem);
                            handleItemRemove(2, item);
                            const Count = item.additem ? Number(item.additem) - 1 : 0;
                            return { ...item, additem: String(Count) };
                        }

                        showToast({ title: `You can select a maximum of ${Required} ${addondata.title}`, id: "error" });
                        return item;
                    }
                }
            }
            return item;
        })
        setCustomisableItem({ ...customisableitem, addondata: FilterData });
    }

    const handleFilterData = (data) => {

        const FilterData = data.subaddondata.map(addon => {
            if (!addon.additem) {
                if (addon.addon_is_radio === "1" && addon.addon_is_required === "1") {
                    setItemState(prev => {
                        const exists = (prev || []).some(item => item.title === data.title);
                        if (exists) {
                            return (prev || []).map(item => {
                                if (item.title === data.title) {
                                    return { ...item, data: [...item.data, addon.subon_item_data[0]] };
                                }
                                return item;
                            });
                        } else {
                            return [{ title: data.title, price: data.price, data: [addon.subon_item_data[0]] }];
                        }
                    });
                    return { ...addon, additem: "1" }
                }
                return addon;
            }
            return addon;
        });

        setSubAddonData({ ...data, subaddondata: FilterData });
    }

    const handleItemAdd = (data) => {
        setItemState(prev => {
            const exists = (prev || []).some(item => item.title === "Order");
            if (exists) {
                return (prev || []).map(item => {
                    if (item.title === "Order") {
                        return { ...item, data: [...item.data, data] };
                    }
                    return item;
                });
            } else {
                return [...(prev || []), { title: "Order", data: [data] }];
            }
        });
    }

    const handleItemRemove = (index, item) => {

        if (index === 1) {
            if (isedit === 0) {
                const updateItems = itemstate.map(List => {
                    const filteredData = List.data.filter(data =>
                        !item.addon_item_data.some(addon => addon.title === data.title)
                    );
                    return { ...List, data: [...filteredData, data] };
                });
                setItemState(updateItems);
            } else {

                if (!hasSubAddon) {
                    const updateItems = itemstate.map(List => {
                        const filteredData = List.data.filter(data =>
                            !item.addon_item_data.some(addon => addon.id === data.id)
                        );
                        return { ...List, data: [...filteredData, data] };
                    });
                    setItemState(updateItems);
                } else {

                    const FilterItem = copyitemstate.filter((item => {
                        return item.title === data.title;
                    }));

                    if (FilterItem.length >= 1) {
                        setItemState(FilterItem);
                    } else {
                        const matchedData = itemstate.map(item => {
                            return addondata.addon_item_data.map(addon => {
                                if (data.id === addon.id) {
                                    return addon.subaddondata.map(subdata => {
                                        return subdata.subon_item_data.filter(subon => {
                                            return item.data.some(itemdata => itemdata.id === subon.id);
                                        })
                                    }).flat();
                                }
                            }).flat();
                        }).flat().filter(Boolean);
                        setItemState([{ title: data.title, price: data.price, data: matchedData }]);
                    }
                }
            }
        } else {
            const updateItems = itemstate.map(List => {
                const filteredData = List.data.filter(item => item.id !== data.id);
                return { ...List, data: filteredData };
            });
            setItemState(updateItems);
        }
    }

    return <div onClick={() => handleSelectItem(data)} className="flex items-center justify-between gap-[10px] pb-[10px] cursor-pointer overflow-hidden">
        <div className="flex items-center gap-[5px]">
            {isVegtype === "1" ?
                <img src={VegIcon} className="w-[15px] mt-[2px]" alt="VegIcon" />
                : <img src={NonVegIcon} className="w-[15px] mt-[2px]" alt="NonVegIcon" />}
            <h1 className="text-[16px] text-[rgba(2,6,12,0.82)] whitespace-nowrap overflow-hidden overflow-ellipsis">{data.title}</h1>
        </div>
        <div className="text-[16px] text-gray-800 flex items-center gap-[10px]">
            <span className='whitespace-nowrap'>{addondata.addon_limit === "0" && "+"} {currency + data.price}</span>
            {addondata.addon_is_radio === "1"
                ? <div className={`${isadded ? "border-[#ff5200]" : "border-gray-500"} border-[2px] rounded-full p-[3px]`}>
                    <div className={`w-[8px] h-[8px] ${isadded ? "bg-[#ff5200]" : "bg-transparent"} rounded-full`}></div>
                </div>
                : <div className={`${isadded ? "bg-[#ff5200] border-[#ff5200]" : "border-gray-500"} border-[2px] rounded-[5px]`}>
                    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M9 17.75C8.999 17.75 8.99799 17.75 8.99699 17.75C8.79699 17.749 8.60599 17.669 8.46499 17.526L4.46499 13.464C4.17399 13.169 4.178 12.694 4.473 12.403C4.768 12.113 5.24399 12.116 5.53399 12.411L9.003 15.935L18.469 6.46902C18.762 6.17602 19.237 6.17602 19.53 6.46902C19.823 6.76202 19.823 7.23705 19.53 7.53005L9.53 17.5301C9.39 17.6711 9.199 17.75 9 17.75Z" fill="white" />
                    </svg>
                </div>}
        </div>
    </div>
}

export default AddonItemData;
